class Index {
    rc;
    _parent;
    phoneNumberId;
    constructor(_parent, phoneNumberId = null) {
        this._parent = _parent;
        this.rc = _parent.rc;
        this.phoneNumberId = phoneNumberId;
    }
    path(withParameter = true) {
        if (withParameter && this.phoneNumberId !== null) {
            return `${this._parent.path()}/phone-number/${this.phoneNumberId}`;
        }
        return `${this._parent.path()}/phone-number`;
    }
    /**
     * Returns the list of phone numbers assigned to RingCentral customer
     * account. Both company-level and extension-level numbers are returned.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/phone-number
     * Rate Limit Group: Heavy
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyPhoneNumbers
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns phone number(s) belonging to a certain account or extension by phoneNumberId(s).
     * [Batch request syntax](https://developers.ringcentral.com/guide/basics/batch-requests) is supported.
     *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/phone-number/{phoneNumberId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyPhoneNumbers
     */
    async get(restRequestConfig) {
        if (this.phoneNumberId === null) {
            throw new Error("phoneNumberId must be specified.");
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
